// extracted by mini-css-extract-plugin
export default {"root":"_2V0_ST-D","item":"wA5n5pKt","icon":"_3jc7LxwF","wrapper":"_224L__Ml","title":"_30iKxz_k","content":"JxGa9r4J"};